<template>
    <div class="apprentice-simple-card">
        <div class="description">
            <design-2021-apprentice-display-html-component :html-content="sluModule.description">
            </design-2021-apprentice-display-html-component>

            <div
                class="labels"
                v-if="sluModule.slu_labels.length">
                <b-badge
                    v-for="label in sluModule.slu_labels"
                    pill
                    :key="label.id"
                    :style="{ backgroundColor: label.color }">
                    {{ label.name }}
                </b-badge>
            </div>

            <div class="points-wrapper">
                <div class="hours"><span class="btn-clock-one-thirty icon"></span>{{ sluModule.hours }} uren</div>

                <span
                    class="school-points"
                    v-if="sluSchoolSettingsIn.hours_to_point">
                    {{ sluModule.hours / sluSchoolSettingsIn.hours_to_point }}
                    <span class="name-points">{{ sluSchoolSettingsIn.name_points }}</span>
                </span>

                <!--                <b-badge class="hours-badge"-->
                <!--                         pill-->
                <!--                         variant="primary">-->
                <!--                    <span class="label">Uren:</span> {{ sluModule.hours }}-->
                <!--                </b-badge>-->
                <!--                <b-badge class="school-points"-->
                <!--                         pill-->
                <!--                         variant="warning"-->
                <!--                         v-if="sluSchoolSettingsIn.hours_to_point">-->
                <!--                    <span class="label">{{sluSchoolSettingsIn.name_points ? sluSchoolSettingsIn.name_points : 'Punten'}}</span>-->
                <!--                    {{ sluModule.hours / sluSchoolSettingsIn.hours_to_point }}-->
                <!--                </b-badge>-->
            </div>
        </div>

        <div class="students">
            <design-2021-apprentice-data-table
                class="slu-module-students"
                :download-excel="excelData"
                :items="tableData"
                :fields="studentFields"
                :show-empty="true">
                <template v-slot:cell(status)="data">
                    <b-form-group>
                        <design-2021-apprentice-multiselect-component
                            class="student-module-status-select"
                            v-model="data.item.status"
                            :options="statusOptions"
                            label="name"
                            :show-labels="false"
                            :disabled="true"
                            :multiple-select="false"
                            track-by="id"
                            @input="updateStudentModuleSatus(data.item)">
                            <template
                                slot="singleLabel"
                                slot-scope="props">
                                <div class="selected-option">
                                    <span
                                        class="tag-color"
                                        :style="{ backgroundColor: `${props.option.color}` }"></span>
                                    <div class="tag-name">{{ props.option.name }}</div>
                                </div>
                            </template>

                            <template
                                slot="option"
                                slot-scope="props">
                                <div class="tag-option">
                                    <span
                                        class="tag-color"
                                        :style="{ backgroundColor: `${props.option.color}` }"></span>
                                    <div class="tag-name">{{ props.option.name }}</div>
                                </div>
                            </template>
                        </design-2021-apprentice-multiselect-component>
                    </b-form-group>
                </template>

                <template #cell(feedback)="data">
                    <div class="feedback">
                        <b-button
                            class="btn-feedback-icon"
                            :class="!data.item.feedback && 'bg-border'"
                            variant="primary-icon-only"
                            :id="`feedback-popover-${data.item.id}`">
                            <i
                                class="fas fa-fw"
                                :class="data.item.feedback ? 'fa-comment-lines' : 'fa-comment-slash'">
                            </i>
                        </b-button>
                        <b-popover
                            custom-class="feedback-popover"
                            :key="data.item.id"
                            :target="`feedback-popover-${data.item.id}`"
                            title="Feedback"
                            triggers="click hover blur"
                            placement="top"
                            :content="data.item.feedback ? data.item.feedback : $t('slu_dashboard.no_feedback_yet')">
                        </b-popover>
                    </div>
                </template>

                <template #cell(actions)="data">
                    <div class="management-actions">
                        <b-button
                            class="btn-edit btn-module-edit"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :title="$t('slu_dashboard.no_feedback_yet')"
                            @click="showEditSluModuleModal(data.item)">
                        </b-button>
                    </div>
                </template>

                <template #empty>
                    <div class="not-found">
                        <div class="icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </div>
                        <div class="alert-notice">{{ $t('slu_dashboard.no_students_found_for_this_module') }}</div>
                    </div>
                </template>
            </design-2021-apprentice-data-table>
            <design-2021-slu-dashboard-module-edit-record-modal-component
                ref="edit-record-modal"
                :status-options="statusOptions"
                :slu-module-in="sluModuleIn"
                :slu-course-in="sluCourseIn"
                :slu-cohort-in="sluCohortIn"
                @record-update="updateStudentModuleSatus">
            </design-2021-slu-dashboard-module-edit-record-modal-component>
        </div>
    </div>
</template>

<script>
    import Design2021ApprenticeMultiselectComponent from '../common/design-2021-apprentice-multiselect-component';

export default {
    name: 'design-2021-slu-dashboard-module-index-component',
    components: { Design2021ApprenticeMultiselectComponent },
    props: ['sluCourseIn', 'sluCohortIn', 'sluModuleIn', 'sluStatusTagsIn', 'sluSchoolSettingsIn'],
    data() {
        return {
            sluStatusTags: this.sluStatusTagsIn,
            sluCourse: this.sluCourseIn,
            sluCohort: this.sluCohortIn,
            sluModule: this.sluModuleIn,
            studentFields: [
                {
                    key: 'full_name',
                    label: this.$t('slu_dashboard.student'),
                },
                {
                    key: 'status',
                    label: this.$t('slu_dashboard.status'),
                },
                {
                    key: 'feedback',
                    label: this.$t('slu_dashboard.feedback'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            return this.sluCohort.users.map((user) => {
                let feedback = null;
                let status = null;
                if (user.slu_module_records[0]) {
                    status = user.slu_module_records[0].slu_status_tag_id;
                    if (status === null && user.slu_module_records[0].completed) {
                        status = 'default_completed';
                    }
                    feedback = user.slu_module_records[0].feedback;
                }
                if (status === null) {
                    status = 'default_not_completed';
                }
                return {
                    id: user.id,
                    full_name: user.full_name,
                    status: this.statusOptions.find((option) => option.id === status), //applied status by teacher.
                    feedback: feedback,
                };
            });
        },
        excelData() {},
        statusOptions() {
            let Tags = this.sluStatusTagsIn;
            const hasCompleted = Tags.findLast((x) => x.finished === true);
            if (Tags.length && hasCompleted) {
                Tags.push({
                    id: 'default_not_completed',
                    name: this.sluSchoolSettingsIn.name_unfinished
                        ? this.sluSchoolSettingsIn.name_unfinished
                        : this.$t('slu_dashboard.unfinished'),
                    color: this.sluSchoolSettingsIn.color_unfinished
                        ? this.sluSchoolSettingsIn.color_unfinished
                        : '#999999',
                });
                return Tags;
            } else if (!Tags.length) {
                return [
                    {
                        id: 'default_not_completed',
                        name: this.sluSchoolSettingsIn.name_unfinished
                            ? this.sluSchoolSettingsIn.name_unfinished
                            : this.$t('slu_dashboard.unfinished'),
                        color: this.sluSchoolSettingsIn.color_unfinished
                            ? this.sluSchoolSettingsIn.color_unfinished
                            : '#999999',
                    },
                    {
                        id: 'default_completed',
                        name: this.$t('slu_dashboard.finished'),
                        color: '#66bb88',
                    },
                ];
            } else {
                Tags.push({
                    id: 'default_not_completed',
                    name: this.sluSchoolSettingsIn.name_unfinished
                        ? this.sluSchoolSettingsIn.name_unfinished
                        : this.$t('slu_dashboard.unfinished'),
                    color: this.sluSchoolSettingsIn.color_unfinished
                        ? this.sluSchoolSettingsIn.color_unfinished
                        : '#999999',
                });
                Tags.push({
                    id: 'default_completed',
                    name: this.$t('slu_dashboard.finished'),
                    color: '#66bb88',
                });

                return Tags;
            }
        },
    },
    methods: {
        openStudent(userId) {
            const user = this.sluCohort.users.find((user) => user.id === userId);
            const status = null; // user.sluModuleStatuses.find(status => status.slu_module_id === this.sluModule.id);
            this.$refs['edit-slu-module-student-status-modal'].show(user, status);
        },

        updateStudentModuleSatus(student) {
            let data = {
                userId: student.id,
                moduleId: this.sluModuleIn.id,
                cohortId: this.sluCohortIn.id,
                courseId: this.sluCourseIn.id,
                feedback: student.feedback,
            };
            if (student.status.id === 'default_not_completed') {
                data.completed = false;
            } else if (student.status.id === 'default_completed') {
                data.completed = true;
            } else {
                data.statusTagId = student.status.id;
                data.completed = student.status.finished;
            }

            axios.post(this.routes.sluModuleRecord(), data).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        showEditSluModuleModal(record) {
            this.$refs['edit-record-modal'].show(record);
        },
    },
};
</script>

<style scoped lang="scss">
.selected-option,
.tag-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: 8px;

    .tag-color {
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 50%;
    }
}

.slu-module-students ::v-deep {
    .table-responsive {
        overflow: inherit;
    }

    tbody tr {
        &:nth-of-type(even) {
            .multiselect__tags {
                background-color: $white;
            }
        }

        &:hover {
            .multiselect__tags {
                background-color: var(--primaryLighter);
            }
        }
    }
}

.description {
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    line-height: 1.5;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.points-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    //.badge {
    //    font-size: 0.8125rem;
    //    font-weight: $font-weight-medium;
    //    padding: map-get($grid-gutter-spacing, 'five') map-get($grid-gutter-spacing, 'ten');
    //}

    .hours,
    .school-points {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        font-size: $base-font-size;
        font-weight: $font-weight-medium;

        .icon {
            font-style: normal;
            font-weight: $font-weight-normal;
            color: $orange;
            margin-right: map-get($grid-gutter-spacing, 'eight');

            &:before {
                margin-right: 0;
            }
        }

        .name-points {
            color: $orange;
            font-size: 0.75rem;
            margin-left: map-get($grid-gutter-spacing, 'eight');
        }
    }
}

.labels {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    column-gap: map-get($grid-gutter-spacing, 'ten');
    row-gap: map-get($grid-gutter-spacing, 'ten');

    .badge {
        color: $white;
        font-size: 0.75rem;
        font-weight: $font-weight-medium;
        padding: map-get($grid-gutter-spacing, 'five') map-get($grid-gutter-spacing, 'ten');
    }
}

.student-module-status-select ::v-deep {
    width: auto;

    .multiselect__select {
        display: none;
    }

    .multiselect__tags {
        border: none;
        border-radius: 0;
        padding-left: 0;
    }

    input.multiselect__input {
        border: none;
    }

    &.multiselect--disabled {
        opacity: 1;
        background: inherit;
    }
}

.feedback {
    .btn-feedback-icon i {
        font-size: 1.5625rem;
    }

    .bg-border {
        color: $text-muted-color;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .student-module-status-select ::v-deep {
        width: 200px;
    }
}
</style>
